import { render, staticRenderFns } from "./OktruExample.vue?vue&type=template&id=2e9fd84c&scoped=true&"
import script from "./OktruExample.vue?vue&type=script&lang=ts&"
export * from "./OktruExample.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9fd84c",
  null
  
)

export default component.exports